<template>
  <b-tabs
    horizontal
    content-class="col-12 col-md-12 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-12 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">البيانات العامة والفروع</span>
      </template>

      <account-setting-general @generalSettingsUpdated="setGeneralSettingsUpdated()" />
    </b-tab>
    <!--/ general tab -->

    <!-- social links -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">مواقع التواصل الإجتماعي</span>
      </template>

      <account-setting-social />
    </b-tab>

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">تعديل كلمة المرور</span>
      </template>

      <account-setting-password />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import userApi from '@/axios/api/user'
import store from '@/store'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingSocial from './AccountSettingSocial.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingSocial,
  },
  data() {
    return {
      user: {},
    }
  },
  mounted() {
    this.user = store.getters['user/user']
    if (this.user === {}) {
      userApi.me()
        .then(response => {
          store.commit('user/user', response.data.data)
          this.user = response.data.data
        }).catch(error => {
          console.error(error)
        })
    }
  },
}
</script>
